
import "./loader.css"
import React from 'react'

export const LoadingPage = () => {
  return (
    <div className="loader"><div className="lds-dual-ring"></div></div>
  )
}
